import { FC } from "react"
import { RenderBlog, RenderContent } from "../graphql/website-blog.graphql"
import { useQuery } from "@apollo/client"
import { Modal, Spin } from "antd"

export type BlogPreviewProps = {
  content?: any
  id?: number
  open: boolean
  onClose: () => void
}

export const BlogPreview: FC<BlogPreviewProps> = ({ content, id, open, onClose }) => {
  const { data: byContent, loading: loadingContent } = useQuery(RenderContent, {
    variables: {
      input: {
        content,
      },
    },
    skip: !open || !content,
  })

  const { data: byId, loading: loadingId } = useQuery(RenderBlog, {
    variables: {
      id: id ?? 0,
    },
    skip: !open || !id,
  })

  return (
    <Modal
      closable
      open={open}
      onCancel={onClose}
      footer={[]}
      width='80%'
    >
      <Spin
        spinning={loadingContent || loadingId}
      >
        <div dangerouslySetInnerHTML={{ __html: byContent?.websiteBlogRenderContent ?? byId?.websiteBlogRenderBlog ?? '' }} />
      </Spin>
    </Modal>
  )
}